import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UrlService } from '../service/url.service';

/**
 * A component that displays an iframe.
 */
@Component({
    selector: 'jhi-iframe-component',
    template: '<iframe #viewport [src]="safeResourceUrl" name="PID_Sbrowser" id="viewport" src="about:blank" style="border: 0; width: 100%; height: 100%"></iframe>'
})
export class IFrameComponent implements OnInit, OnDestroy {

    safeResourceUrl: SafeResourceUrl;
    private subscription: Subscription;

    constructor(private sanitizer: DomSanitizer,
                private activatedRoute: ActivatedRoute,
                private urlService: UrlService
    ) {

    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.subscription = this.activatedRoute.paramMap.subscribe(params => {
            const rawUrl = params.get('url');
            const safeUrl = this.urlService.buildSafeUrl(rawUrl);
            // Fall back to a blank page if the URL is not on the allowlist.
            this.safeResourceUrl = safeUrl !== null
                ? this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl)
                : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
        });
    }

}
